import axios from './httpConfig.js'
//******************出入库管理 -- 组装单 ******************/

// 组装单 列表
export function GetOrderList(param) {
	return axios.post('/admin/assemble/order/list', param)
}

// 删除组装单 整个订单
export function DeleteOrder(param) {
	return axios.post('/admin/assemble/order/delete', param)
}

// 单据的全部信息
export function GetOrderInfo(param) {
	return axios.post('/admin/assemble/order/info', param)
}

// 删除已组装单 订单中的货品
export function DeleteGoods(param) {
	return axios.post('/admin/assemble/order/goods/delete', param)
}

// 导出组装单订单列表
export function ExportOrderList(param) {
	return axios.postBlob('/admin/assemble/order/export', param)
}

// 修改组装单主信息
export function EditMainInfo(param) {
	return axios.post('/admin/assemble/order/edit', param)
}



// 修改已组装单SN
export function EditSN(param) {
	return axios.post('/admin/receipt/sn/edit', param)
} 
// 修改已组装单货位---todo暂无接口
export function EditGoodsLocation(param) {
	return axios.post('/admin/receipt/order/goods/edit', param)
} 

export const assembleRequest = {
	GetOrderList,
	DeleteOrder,
	DeleteGoods,
	GetOrderInfo,
	EditSN,
	EditMainInfo,
	EditGoodsLocation,
	ExportOrderList,
}